// src/theme/theme.js
import { createTheme } from '@mui/material/styles';
import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { breakpoints } from './breakpoints';
import { components } from './components';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      dark: colors.primary.main,
    },
    secondary: {
      main: colors.secondary.main,
      light: colors.secondary.light,
      dark: colors.secondary.main,
    },
    warning: {
      main: colors.warning.main,
      light: colors.warning.light,
      dark: colors.warning.main,
    },
    grey: {
      main: colors.grey.main,
      light: colors.grey.light,
      dark: colors.grey.main,
    },
  },
  typography,
  spacing: spacing.unit,
  breakpoints,
  components,
});

export default theme;